import { Sprite } from 'pixi.js';

import { Shared } from '../App';
import DiamondSprite from './DiamondSprite';
import { defaultOpts, IconSizes, ShopIcon } from './ShopIcon';

const defOpts = {
    ...defaultOpts,
    anchor: { x: 0, y: 0.5 },
    tint: 0x000,
    size: IconSizes.large,
    activeTexture: 'item-holder-large-active',
    inactiveTexture: 'item-holder-large',
    selected: false,
};

export type PaintIconOpts = typeof defaultOpts;

export class PaintIcon extends ShopIcon
{
    protected selectedSprite: Sprite;
    protected coinSprite?: Sprite;
    protected diamondSprite?: DiamondSprite;

    private _unlocked: boolean;
    private _selected: boolean;

    constructor(opts: Partial<PaintIconOpts> = {})
    {
        const o = { ...defOpts, ...opts };

        super(o);

        const offSet = 20;

        const paint = Sprite.from(Shared.assets.getTexture('paint-tint-storeitem'));

        paint.anchor.set(0, 0.5);
        paint.scale.set(1.5);
        paint.tint = o.tint;
        paint.x = offSet;

        const highlight = Sprite.from(Shared.assets.getTexture('paint-highlight-storeitem'));

        highlight.anchor.set(0, 0.5);
        highlight.scale.set(1.5);
        highlight.x = offSet;

        this.view.addChild(paint);
        this.view.addChild(highlight);

        this.selectedSprite = Sprite.from(Shared.assets.getTexture('equipped-tick'));
        this.selectedSprite.anchor.set(0, 1);
        this.selectedSprite.scale.set(1.5);
        this.selectedSprite.x = o.size - (3 * this.selectedSprite.width / 4);
        this.selectedSprite.y = o.size - (this.selectedSprite.height * 1.2);
        this.view.addChild(this.selectedSprite);

        this._unlocked = o.unlocked;
        this._selected = o.selected;

        if (!o.unlocked)
        {
            if (o.diamondCost)
            {
                this.diamondSprite = DiamondSprite.from(Shared.assets.getTexture('diamond-small'));
                this.diamondSprite.anchor.set(0, 1);
                this.diamondSprite.scale.set(1.3);
                this.diamondSprite.x = o.size - (3 * this.diamondSprite.width / 4);
                this.diamondSprite.y = o.size - (3 * this.diamondSprite.height / 4);
                this.view.addChild(this.diamondSprite);
            }
            if (o.coinCost)
            {
                this.coinSprite = Sprite.from(Shared.assets.getTexture('coins-small'));
                this.coinSprite.anchor.set(0, 1);
                this.coinSprite.scale.set(1.3);
                this.coinSprite.x = o.size - (3 * this.coinSprite.width / 4);
                if (this.diamondSprite) this.coinSprite.x -= (this.diamondSprite.width * 0.8);
                this.coinSprite.y = o.size - (3 * this.coinSprite.height / 4);
                this.view.addChild(this.coinSprite);
            }
        }
    }

    public get state(): boolean { return this.active; }
    public set state(state: boolean)
    {
        this.active = state;
        this.view.texture = this.active ? this.activeTexture : this.inactiveTexture;
        
    }

    public get unlocked(): boolean { return this._unlocked; }
    public set unlocked(val: boolean)
    {
        this._unlocked = val;

        if (this.coinSprite) this.coinSprite.visible = !val && !this.active;
        if (this.diamondSprite) this.diamondSprite.visible = !val && !this.active;
    }

    public get selected(): boolean { return this._selected; }
    public set selected(val: boolean)
    {
        this._selected = val;
        this.selectedSprite.visible = val;//this.active;
    }
}
